var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-1" },
    [
      !_vm.oficio.protocolo && _vm.showModalEditarOficio
        ? _c("modal-editar-oficio", {
            attrs: {
              documentoId: _vm.oficio.id,
              oficio: _vm.oficio,
              titulo: "Editar Ofício"
            },
            on: {
              closeModal: _vm.closeModalEditarOficio,
              onUpdatePDF: _vm.onUpdatePDF
            }
          })
        : _vm._e(),
      _vm.bytes
        ? _c("div", [_c("app-pdf-viewer", { attrs: { bytes: _vm.bytes } })], 1)
        : _vm._e(),
      _c(
        "div",
        { staticClass: "mt-1" },
        [
          _vm.showEditar()
            ? _c(
                "el-button",
                { staticClass: "align", on: { click: _vm.showModal } },
                [
                  _c("i", { staticClass: "fal fa-file-pdf" }),
                  _c("span", [_vm._v("  Editar ofício")])
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ddc4734", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ddc4734","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/arrecadacao/cpat/components/matricula/ConfirmarMatricula.vue
// module id = null
// module chunks = 